export const environment = {
  firebase: {
    projectId: 'aguacate-wallet-qa',
    appId: '1:455461068324:web:703b6f15fa5312448ec2b1',
    storageBucket: 'aguacate-wallet-qa.appspot.com',
    apiKey: 'AIzaSyB532JuLd5JDhWc43qPlWPA-ZcXRuJflgc',
    authDomain: 'aguacate-wallet-qa.firebaseapp.com',
    messagingSenderId: '455461068324',
    measurementId: 'G-CMJ0LWH3C2',
    applicationServerKey: 'BP4XiQR6lR20NC2R23Cj1MuvpurOVlF9AP7BOk7GXhHCXXMJQuhWt2Q6-k-ES9J2YvLPXdhVM1r8hrCQQRxXCSI'
  },
  production: true,
  apiGatewayURL: 'https://w3eswmitz1.execute-api.us-east-1.amazonaws.com/prod/',
  apiGatewayRetailUrl: 'https://fo1v3634dd.execute-api.us-east-1.amazonaws.com/prod/',
  cognito: {
    userPoolId: 'us-east-1_qVPVhyS5j',
    userPoolWebClientId: '7g6p2q4hask10oi8ocnfgmqo3d',
    mandatorySignIn: false,
    region: 'us-east-1',
    identityPoolId: 'us-east-1:c1d135a7-4200-4303-ba7a-790a2928b3ab'

  },
  // Solo metadatos públicos del bucket — el frontend NUNCA firma URLs.
  // Las pre-signed URLs vienen del backend (S3UrlService).
  s3: {
    bucket: 'aguacatewalletdata',
    region: 'us-east-1',
    identityPoolId: 'us-east-1:e88d2a0b-195f-4ad3-b44b-70bd63c94ec4'
  },
  apiNest: 'https://wallet-api.aguacatewallet.com/',
  apiKyc: 'https://cafngpryec.execute-api.us-east-1.amazonaws.com/prod/kyc/v1/',
  // Habilita el modulo binance-link para OPERADORES en todos los ambientes
  // (prod, qa, dev). Los clientes NO acceden — el bloqueo cliente NO depende
  // de este flag, sino del filtro por rol en el sidebar
  // (*ngIf="userRole === rolesEnum.aguacate_operator") + del OperatorGuard
  // sobre la ruta /wallet/admin/wallets-usuarios + del AguacateOperatorGuard
  // en cada endpoint backend. Doble defensa.
  // Cambiar este flag a `false` solo si se quiere ocultar el modulo TAMBIEN
  // a operadores (kill-switch global).
  binanceLinkEnabled: true,
  // Registro de empresas: flujo nuevo de 12 pasos dentro de dinamic-signup.
  //
  // ENCENDIDO en produccion desde el 28-ago-2026, por decision explicita y
  // ANTES de que ningun registro haya pasado de punta a punta ni consolidado.
  // Queda dicho para que nadie lo lea como que esa verificacion ya se hizo:
  // sigue pendiente, y con ella el chequeo de que `es_pep` llegue por `data6` y
  // de que los campos crudos del OCR en `data4` sean los que exige la
  // consolidacion.
  //
  // Apagarlo es el rollback: con `false` la empresa termina en el OTP de
  // WhatsApp (4 pasos) y sale al dashboard, igual que siempre, y el
  // ActivateGuard la manda al monolito `company-registration`. No hay migracion
  // ni datos que revertir; los pre-registros ya empezados siguen su camino por
  // el monolito, que sabe reanudarlos.
  empresaSignupV2Enabled: true,
  // "Movimientos Vita" fuera del sidebar en prod: la ruta sigue viva y se entra
  // solo por URL (/wallet/admin/vita-movimientos).
  vitaMovimientosEnSidebar: false,
};
